import React, { useEffect, useRef, useState } from 'react';
import Like from '../../../../../Assets/Lens/Like.svg';
import LikeGreen from '../../../../../Assets/Lens/LikeGreen.svg';
import { formatBadge, formatDescription, formatNumber, formatTimeDifference, getCachedMediaUrl, getInitials } from '../../../../../lib/utils/utils';
import { checkLikeOnComment, getPostProfile, likeComment, unlikeComment } from '../../../../../lib/utils/apiCalls';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, setSelectedComment } from '../../../../../Features/lensSlice';
import CommentKebab from './CommentKebab';
import VerticalDot from '../../../../../Assets/VerticalDot.svg';
import { useOutsideClickForTwoRef } from '../../../../../Hooks/useOutsideClickForTwoRef';
import { useLocation, useNavigate } from 'react-router-dom';

function ChildComment({ comment, mention }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const [userProfile, setUserProfile] = useState({});
    const [commentLikesCount, setCommentLikesCount] = useState(0);
    const [likedByUser, setLikedByUser] = useState(false);

    const commentActionButtonRef = useRef(null);
    const commentKebabRef = useRef(null);

    useOutsideClickForTwoRef(commentActionButtonRef, commentKebabRef, () => {
        setCommentKebabOpen(false);
        dispatch(setSelectedComment({}));
    });

    const [commentKebabOpen, setCommentKebabOpen] = useState(false);

    const selectedComment = useSelector((state) => state.lens.modal.selectedComment);

    const handleCommentLikeClick = async () => {
        if(likedByUser) {
            try {
                const response = await unlikeComment(comment.id);
                setCommentLikesCount(response.noOfLikes);
            }
            catch(err) {
                console.error(err);
            }
        }
        else {
            try {
                const response = await likeComment(comment.id);
                setCommentLikesCount(response.noOfLikes);
            }
            catch(err) {
                console.error(err);
            }
        }
        try {
            const response = await checkLikeOnComment(comment.id);
            setLikedByUser(response);
        }
        catch(err) {
            console.error(err);
        }
    }

    useEffect(() => {
        setCommentLikesCount(comment.noOflikes);
        const userId = comment.UserId || comment.SellerUserId;

        const getUserProfile = async () => {
            const profile = await getPostProfile(userId);
            setUserProfile(profile);
        }

        const checkUserLikeOnComment = async () => {
            const response = await checkLikeOnComment(comment.id);
            setLikedByUser(response);
        }

        Object.keys(comment).length > 0 && getUserProfile();
        Object.keys(comment).length > 0 && checkUserLikeOnComment();
    }, [comment]);

    const handleCommentActionButtonClick = () => {
        if(selectedComment.id === comment.id) {
            setCommentKebabOpen(false);
            dispatch(setSelectedComment({}));
        }
        else {
            dispatch(setSelectedComment(comment));
            setCommentKebabOpen(true);
        }
    }

    const handleCommentUserClick = () => {
        const userId = comment.UserId || comment.SellerUserId;
        dispatch(closeModal());
        navigate(`${location.pathname}/profile/${userId}`);
    }

    return (
        <div className={'flex gap-[5px] w-[calc(100%-32px)] ml-auto'}>
            <div className="w-8 h-8 rounded-full overflow-hidden">
                {
                    userProfile?.ProfilePic ? 
                    <img className='w-full h-full object-cover' src={getCachedMediaUrl(userProfile.ProfilePic)} alt="" /> : 
                    <div className='w-full h-full bg-[#EAEAEA] flex items-center justify-center'>
                        <p className='font-mulish font-bold text-[14px] leading-4 text-[#666666]'>{comment.UserId ? getInitials(userProfile?.fullName) : getInitials(userProfile?.name)}</p>
                    </div>
                }
            </div>

            <div className="flex flex-col gap-1 w-[calc(100%-32px)]">
                <div className="flex items-center justify-between">
                    <div className="flex items-baseline gap-1 font-semibold select-none">
                        <p onClick={handleCommentUserClick} className='text-[14px] leading-[26px] hover:underline cursor-pointer'>{comment.UserId ? userProfile?.fullName : userProfile?.name}</p>

                        <span className='text-[10px] leading-3 text-[#808080]'>
                            {
                                comment.UserId ? 
                                (userProfile.milestone ? `${userProfile.milestone === 'No Review' ? userProfile.milestone : `${formatBadge(userProfile.milestone)}`}` : '') : 
                                `${userProfile.favourite ? formatNumber(userProfile.favourite) : '0'} Shoppers' Favorite`
                            }
                        </span>
                    </div>

                    <div className="flex items-center gap-3">
                        <div className="flex items-center gap-[10px]">
                            <div className="rounded-full w-1 h-1 bg-[#757575]"></div>

                            <p className='font-normal text-[12px] leading-6 text-[#A0A0A0]'>{formatTimeDifference(comment?.createdAt)} ago</p>
                        </div>

                        <div onClick={handleCommentActionButtonClick} ref={commentActionButtonRef} className="relative size-6 flex items-center justify-center outline-none cursor-pointer">
                            <img className='select-none' src={VerticalDot} alt="" />

                            {
                                selectedComment.id === comment.id && 
                                <CommentKebab 
                                    kebabOpen={commentKebabOpen} 
                                    boxRef={commentKebabRef} 
                                    comment={comment} 
                                />
                            }
                        </div>
                    </div>
                </div>

                <div className="w-[95%]">
                    <p className='w-full font-normal text-[12px] leading-6 text-[#121212]'>
                        {/* {mention && <span className='font-bold cursor-pointer text-primaryColor'>Saiful Ameen </span>} */}
                        <span dangerouslySetInnerHTML={{ __html: formatDescription(comment?.comment) }} />
                    </p>

                    <div className="flex items-center gap-[10px] py-1">
                        <div className="flex items-center">
                            <div className="w-[38px] h-[38px] flex items-center justify-center">
                                <button onClick={handleCommentLikeClick}>
                                    <img src={likedByUser ? LikeGreen : Like} alt="" />
                                </button>
                            </div>

                            <p className='font-normal text-[14px] leading-[26px] text-[#B0B0B0]'>{commentLikesCount}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChildComment;
